import authService from "@lib/services/AuthService";
import { useConfigurationStore, useUserPreferencesStore } from "@stores";

import localStorageKeys from "@constants/localStorageKeys";
import { URLS } from "@constants/urls";

const userStore = useUserPreferencesStore;
const { getState: getUserPreferencesState } = userStore();
const { resetSettings } = getUserPreferencesState() ?? {};
const { getState: getConfigurationState } = useConfigurationStore;
const { setUserProfile } = getConfigurationState();

export const handleSSOLogout = (tokenExpired: boolean): void => {
  const isAutologinPage = window.location.href.includes(URLS.autologin);

  // We need to allow autologin to handle the token expiration and login/logout process
  if (isAutologinPage) {
    return;
  }

  if (tokenExpired) {
    window.location.replace(URLS.login);
  }

  const ssoLogoutUrl = localStorage.getItem(localStorageKeys.SSO_LOGOUT_URL);

  authService.removeRole();
  resetSettings();
  setUserProfile(null);

  ssoLogoutUrl
    ? // Redirect to sso logout url
      window.location.replace(ssoLogoutUrl)
    : // Logout
      window.location.replace(URLS.login);
};
